<!--
 * @Author: your name
 * @Date: 2021-07-19 21:27:55
 * @LastEditTime: 2021-08-03 14:22:19
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /b_c_i18n/src/components/NoList/index.vue
-->
<template>
  <div class="no-list" :style="{ 'margin-top': imgTop }">
    <img :src="noImg" alt="" class="no-list_icon" />
    <div class="no-list_text" v-if="noText">{{ noText }}</div>
    <div class="no-list_text_desc" v-if="noDesc">{{ noDesc }}</div>
  </div>
</template>

<script>
import i18n from '@/i18n/locale';

import NOLISTICON from '../../assets/images/didi/no_result_icon.png';
Object.freeze(NOLISTICON);
export default {
  name: 'NoList',
  props: {
    noImg: {
      type: String,
      default: NOLISTICON,
      required: false,
    },
    noText: {
      type: String,
      default: i18n.t('抱歉，未找到任何结果'),
      required: false,
    },
    noDesc: {
      type: String,
      default: '',
      required: false,
    },
    imgTop: {
      type: String,
      default: '0',
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.no-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .no-list_icon {
    // margin-top: -30px;
    width: 120px;
    height: 120px;
  }
  .no-list_text {
    font-family: 'Aspira Light';
    font-size: 12px;
    color: #000000;
    text-align: center;
    font-weight: 200;
    width: 326px;
    line-height: 16px;
  }
}
@media screen and (max-width: 768px) {
  .no-list {
    .no-list_icon {
      width: rem(300);
      height: rem(300);
    }
    .no-list_text {
      width: rem(500);
      font-family: 'Aspira Medium';
      font-size: rem(36);
      line-height: rem(44);
      color: #000000;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
